// extracted by mini-css-extract-plugin
export var button = "MenuSection-module--button--496e5";
export var chevronIcon = "MenuSection-module--chevron-icon--4299d";
export var desktopOnly = "MenuSection-module--desktopOnly--dcdd4";
export var mobileOnly = "MenuSection-module--mobileOnly--5f95e";
export var primarySection = "MenuSection-module--primary-section--22b9d";
export var sectionGroups = "MenuSection-module--section-groups--57385";
export var variantLegacy = "MenuSection-module--variant-legacy--dd446";